import type { FlowTemplate } from "./types";

export type {
  FlowTemplate,
  FlowTemplateCategory,
  FlowTemplateComponent,
  FlowTemplateLayout,
  FlowTemplatePage,
} from "./types";
export { TEMPLATE_CATEGORIES } from "./types";

// English template
import { advisoryMultiPortfolioStandard } from "./en_GB";

// Norwegian templates
import { advisoryMultiPortfolioStandardNO } from "./nb_NO";

/**
 * All available flow templates
 */
export const FLOW_TEMPLATES: FlowTemplate[] = [
  // English
  advisoryMultiPortfolioStandard,

  // Norwegian
  advisoryMultiPortfolioStandardNO,
];
